export default __webpack_public_path__ + "static/media/01.de931744.png";